<template lang="pug">
PrText(v-bind="$props")
  slot
</template>

<script>
import styled from "vue-styled-components"

const Props = {
  size: String,
  weight: String,
  muted: Boolean,
  ellipsis: Boolean
}

const PrText = styled("p", Props)`
  font-size: ${props => (props.size ? props.theme.font[props.size] : props.theme.font.base)};
  line-height: ${props => props.theme.font.lineHeight};
  opacity: ${props => (props.muted ? 0.7 : 1)};
  font-weight: ${props => (props.weight ? props.theme.font[props.weight] : props.theme.font.light)};
  margin: 0;

  ${props =>
    props.ellipsis ? "white-space: nowrap; overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;" : "white-space: normal;"}

  b {
    font-weight: ${props => props.theme.font.bold};
  }

  p:last-child {
    margin: 0;
  }
`
export default {
  name: "pr-text",
  components: {
    PrText
  },
  props: Props
}
</script>
